"use client";

import { useComebackUrl } from "@/components/hooks/use-comeback-url";
import { appUrl } from "@/utils/app-url";
import { useEffect } from "react";

export function useZendeskSsoRedirect(redirect?: string) {
  const { setComebackUrl } = useComebackUrl();

  // Zendesk SSO用のパラメータを事前に抽出
  const isZendeskSso = redirect?.includes("zendesk/sso");
  const returnTo =
    isZendeskSso && redirect
      ? (() => {
          try {
            const url = new URL(redirect, "http://dummy.com"); // 相対URLでも処理できるようにダミーベースURL
            return url.searchParams.get("return_to") || "";
          } catch {
            return "";
          }
        })()
      : "";

  // redirectパラメータのバリデーション - zendesk/ssoを含み、return_toがある場合のみ許可
  useEffect(() => {
    if (isZendeskSso && returnTo && redirect) {
      setComebackUrl(appUrl(redirect));
    }
  }, [redirect, isZendeskSso, returnTo, setComebackUrl]);

  return { isZendeskSso, returnTo };
}
